export enum CallTab {
  NOTES = "notes",
  POIS = "trackers",
  CLIPS = "clips",
  TRANSCRIPT = "transcript",
  TRAINING = "training",
  AI_NOTES = "ai_notes",
  SCORES = "scores",
}

export const isCallTab = (s: string): s is CallTab =>
  [
    CallTab.NOTES,
    CallTab.POIS,
    CallTab.CLIPS,
    CallTab.TRANSCRIPT,
    CallTab.TRAINING,
    CallTab.AI_NOTES,
    CallTab.SCORES,
  ].includes(s as any);
